import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ConfirmationService, MessageService } from 'primeng/api';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { ConstantService } from "app/Shared/Services/constant-service";
import { UserService } from "app/Shared/Services/user.service";
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { HttpErrorResponse } from '@angular/common/http';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { DialogModule } from 'primeng/dialog';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LowerCasePipe, CommonModule, SlicePipe } from "@angular/common";
import { MatChipsModule } from '@angular/material/chips';
import { FormsModule} from "@angular/forms";
import { InputMaskModule } from "primeng/inputmask";
import { InputNumberModule } from "primeng/inputnumber";
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from "primeng/toast";
import { Select } from "primeng/select";

@Component({
    selector: 'app-mass-correction',
    imports: [DialogModule, MatAccordion, MatExpansionModule, MatTooltipModule, CommonModule, MatChipsModule, Select,
        InputMaskModule, InputNumberModule, ConfirmDialogModule, MatProgressSpinner, ButtonModule, FormsModule, LowerCasePipe, SlicePipe, ToastModule],
    templateUrl: './mass-correction.component.html',
    styleUrls: ['./mass-correction.component.scss']
})
export class MassCorrectionComponent implements OnInit {
  isDataLoading: boolean = false;
  @Input('totalRecords') totalRecords: number = 0;
  @Input('pageName') pageName!: string;
  @Input('defaultFilters') defaultFilterArray: any[] = [];
  @Input('hasComponentAPICall') hasComponentAPICall: any = false;
  @Input('massCorrectionColumns') massCorrectionCols: any[] = [];
  @Output() updateMassCorrectionField: EventEmitter<any> = new EventEmitter<any>();
  isClickedOnce!: boolean;
  filterItems: any[] = [];
  massCorrectionFields: any[] = [];
  massUpdatedFieldDetails: any[] = [];
  filterFields: any[] = [];
  filterFieldValues: any[] = [];
  optedFilterFieldDetail: any[] = [];
  showMessage:boolean=false;
  showMessageDetails="";

  constructor(public constantService: ConstantService,
    public userService: UserService,
    private urlsService: UrlsService,
    private confirmationService: ConfirmationService,
    private sharedHttpClientService: SharedHttpClientService,
    private messageService: MessageService) {
  }

  ngOnInit() {
    this.addDialogboxRow(); // Initialize DialogBox Row

    // Display Filter
    this.filterItems = this.defaultFilterArray.filter((filterParam) => (filterParam.values != '' || filterParam.values.length > 0));

    // Prepare Update Filter Dropdown Values
    if (this.massCorrectionCols.length > 0) {
      for (let j = 0; j < this.massCorrectionCols.length; j++) {
        this.massCorrectionFields.push({ "label": this.massCorrectionCols[j].ui_columnname, "value": this.massCorrectionCols[j].mappingkey });
      }
    }

    // Prepare Field Values for DataType Dropdown
    let massCorrectionDropDownFields = this.massCorrectionCols.filter((fieldDetail) => fieldDetail.dropdown === "YES" && fieldDetail.dropdownvalue.length === 0);
    if (massCorrectionDropDownFields.length > 0) {
      for (let i = 0; i < massCorrectionDropDownFields.length; i++) {
        let dropDownFieldDetail = this.userService.CAT_Field_Dictionary.filter((fieldDetail: { field_Name: any; }) => fieldDetail.field_Name === massCorrectionDropDownFields[i].db_columnname);
        let dropDownFieldData = dropDownFieldDetail[0].dropdownvalue.map(function (fieldDetail: { label: any; value: any; }) { return { label: fieldDetail.label, value: fieldDetail.value } });

        let dropDownFieldIndex = this.massCorrectionCols.findIndex((fieldDetail) => fieldDetail.db_columnname === massCorrectionDropDownFields[i].db_columnname);
        this.massCorrectionCols[dropDownFieldIndex].dropdownvalue = dropDownFieldData;
      }
    }

    // Prepare Field Values for DataType Boolean
    let massCorrectionBooleanFields = this.massCorrectionCols.filter((fieldDetail) => fieldDetail.datatype === "Boolean");
    if (massCorrectionBooleanFields.length > 0) {
      let booleanFieldData = [{ label: 'Please select value', value: '' }, { label: 'True', value: true }, { label: 'False', value: false }];
      for (let i = 0; i < massCorrectionBooleanFields.length; i++) {
        let booleanFieldIndex = this.massCorrectionCols.findIndex((fieldDetail) => fieldDetail.db_columnname === massCorrectionBooleanFields[i].db_columnname);
        this.massCorrectionCols[booleanFieldIndex].dropdownvalue = booleanFieldData;
      }
    }
  }

  addDialogboxRow() {
    this.massUpdatedFieldDetails = [...this.massUpdatedFieldDetails, {"filterField": "", "filterFieldValue": "", "filterFieldDataType": ""}];
  }

  removeDialogboxRow(rowIndex: number) {
    this.massUpdatedFieldDetails.splice(rowIndex, 1);
    this.optedFilterFieldDetail.splice(rowIndex, 1);
  }

  getFilterFieldChoices(index: number) {
    this.massUpdatedFieldDetails[index].filterFieldValue = '';
    this.optedFilterFieldDetail[index] = this.massCorrectionCols.filter((fieldDetail) => fieldDetail.db_columnname === this.massUpdatedFieldDetails[index].filterField);
    if(this.optedFilterFieldDetail[index] && this.optedFilterFieldDetail[index].length > 0) {
      this.massUpdatedFieldDetails[index].filterFieldDataType = this.optedFilterFieldDetail[index][0]["datatype"];
    }
  }

  closeDialogbox() {
    this.userService.showMassCorrection = false;
  }

  updateDialogbox() {

    let validFieldFormat = true;
    for(let i=0; i < this.massUpdatedFieldDetails.length; i++) {
      let selectedFiterField = this.massCorrectionCols.filter((fieldDetail) => fieldDetail.db_columnname === this.massUpdatedFieldDetails[i].filterField);

      /* Validate Field Value */
      if(selectedFiterField.length > 0 && selectedFiterField[0]["regularexpressions"]) {
        for(let j=0; j < selectedFiterField[0]["regularexpressions"].length; j++) {
          if(new RegExp(selectedFiterField[0]["regularexpressions"][j]).test(this.massUpdatedFieldDetails[i].filterFieldValue)===false) {
            validFieldFormat = false;
            this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_ERROR, summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: 'Please enter correct value of ' + selectedFiterField[0]["ui_columnname"] });
            break;
          }
        }
      }

      /* Validate Mandatory Comment Field */
      if(selectedFiterField[0]["isMandatoryComment"] && this.massUpdatedFieldDetails[i].filterFieldValue.length > 0 && !this.massUpdatedFieldDetails[i].filterFieldMandatoryComment) {
        validFieldFormat = false;
        this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_ERROR, summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: 'Please enter comment for ' + selectedFiterField[0]["ui_columnname"] });
        break;
      }
    }

    if(!validFieldFormat) {
      return false;
    }

    /* Prepare Mass Correction Fields & its Core Object */
    let massUpdatedFields = this.massUpdatedFieldDetails.filter((rowObj) => (rowObj.filterFieldValue.toString().length > 0));
    let massUpdatedFieldsObject: any = new Object();
    for(let k=0; k<massUpdatedFields.length; k++) {
      massUpdatedFieldsObject[massUpdatedFields[k]["filterField"]] = massUpdatedFields[k]["filterFieldValue"].toString();
    }

    /* Confirmation Popup */
    if (this.massUpdatedFieldDetails && this.massUpdatedFieldDetails.length > 0) {
      const filterData = JSON.parse(JSON.stringify(this.defaultFilterArray));
      if (filterData[0].values.length === 2) {
        filterData[0].values[0] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[0])));
        filterData[0].values[1] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[1])));
      }

      /* Return call on the basis of Parent Component has API call OR not */
      if(this.hasComponentAPICall) {
        this.confirmationService.confirm({
          message: 'Are you sure that you want to Update the field for selected records ?',
          key: 'informationDialogue',
          acceptLabel: 'Ok',
          acceptIcon:'pi pi-check',
          rejectLabel: 'No',
          rejectIcon:'pi pi-times',
          acceptButtonStyleClass:"confirm-dialog-button",
          rejectButtonStyleClass:"confirm-dialog-button",
    
          accept: () => {
            let payload = {
              mpid: this.userService.getActiveMPID(),
              user: this.userService.getUserFirstName(),
              data: filterData,
              massUpdatedFields: massUpdatedFields,
              massUpdatedFieldDetailObject: massUpdatedFieldsObject
            };
            this.updateMassCorrectionField.emit(payload);
          }
        });        
      } else {
        let eventTypeIndex = this.defaultFilterArray.findIndex((fieldDetail) => fieldDetail.columnname === "type");
        let selectedEventTypes = this.defaultFilterArray[eventTypeIndex].values.map((item: string) => "'" + item + "'").join(", ");
        this.confirmationService.confirm({
          message: 'Are you sure that you want to Update the field for selected records ?',
          key: 'informationDialogue',
          acceptLabel: 'Ok',
          acceptIcon:'pi pi-check',
          rejectLabel: 'No',
          rejectIcon:'pi pi-times',
          acceptButtonStyleClass:"confirm-dialog-button",
          rejectButtonStyleClass:"confirm-dialog-button",

          accept: () => {
            this.isDataLoading = true;
            this.isClickedOnce = true;
            let payload = {
              mpid: this.userService.getActiveMPID(),
              eventTypes: selectedEventTypes,
              user: this.userService.getUserFirstName(),
              data: filterData,
              massUpdatedFields: massUpdatedFields,
              massUpdatedFieldDetailObject: massUpdatedFieldsObject
            };
            this.performMassCorrection(payload, filterData);
          }
        });
      }
    }

    return true;
  }


  performMassCorrection(payload : any, filterData: any) {
    this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.FINRA_EXCEPTION + APIURL.Mass_Exception_Correction
      ), payload).subscribe({
          next: (response:any) => {
          let resultSet: any = response;
          this.isClickedOnce = false;
          this.isDataLoading = false;
          if (resultSet.response.status) {
            this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_SUCCESS, summary: this.constantService.MESSAGE_SUMMARY_SUCCESS, detail: "Mass Correction Succeeded" });
            this.userService.logUserActivity('Mass Correction', null, {
              'Text1': 'Mass Correction performed successfully | User Filters: ' + this.getFilterDetails(),
              'Text2': 'User Filter Parameters: ' + this.getFilterParameters(filterData)
            });
            this.updateMassCorrectionField.emit(payload);
          } else {
            this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_ERROR, summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: 'Mass Correction Failed' });
            this.userService.logUserActivity('Mass Correction', null, {
              'Text1': 'Error while performing Mass Correction | User Filters: ' + this.getFilterDetails(),
              'Text2': 'User Filter Parameters: ' + this.getFilterParameters(filterData)
            });
          }
        },
        error: (err: HttpErrorResponse) => {
          this.isClickedOnce = false;
          this.isDataLoading = false;          
          if (err.status === 504) {
                this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_INFO, summary: this.constantService.MESSAGE_SUMMARY_INFO, detail: this.constantService.MESSAGE_MASS_CORRECTION_ERROR_MSG });
                this.showMessageBox(this.constantService.MESSAGE_MASS_CORRECTION_ERROR_MSG,true);
          }else{
            this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_ERROR, summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: 'Mass Correction Failed' });  
          }
          this.userService.logUserActivity('Mass Correction', null, {
            'Text1': 'Error while performing Mass Correction | User Filters: ' + this.getFilterDetails(),
            'Text2': 'User Filter Parameters: ' + this.getFilterParameters(filterData)
          });
        }
      });
  }


  getFilterParameters(filterData: any) {
    let filterParam: any;
    if (filterData) {
      filterParam = filterData.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0));
      return JSON.stringify(filterParam);
    }
    return '';
  }

  getFilterDetails() {
    let msg = '';

    let massUpdatedFields = this.massUpdatedFieldDetails.filter((rowObj) => (rowObj.filterFieldValue.toString().length > 0));
    for(let i=0; i < massUpdatedFields.length; i++) {
      let selectedFiterField = this.massCorrectionCols.filter((fieldDetail) => fieldDetail.db_columnname === massUpdatedFields[i].filterField);

      msg += (i > 0 ? ", " : "") + selectedFiterField[0]["ui_columnname"] + ": " + massUpdatedFields[i].filterFieldValue;
    }

    return msg;
  }

  showMessageBox(message: any,status:any) {
    this.showMessage=true;
    this.showMessageDetails=message;
  }
}